import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AuthModals } from "../config/const";
import { setActiveAuthModalAction } from "../redux/app/actions";

export const RouteType = {
  Public: "public",
  Protected: "protected",
};

export const useAppNavigate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuth } = useSelector((state) => state.auth);

  return {
    appNavigate: (url = "", type = RouteType.Protected) => {
      if (!isAuth && type === RouteType.Protected) {
        dispatch(setActiveAuthModalAction(AuthModals.Login));
        return;
      }
      navigate(url);
    },
  };
};
